<template>
	<div class="">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-copy"></i> 操作证查看</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-tabs v-model="ceractiveName" @tab-click="handleClick">
				<el-tab-pane label="全部" name="cerfirst">
					<el-form ref="allcertificateform" :model="allcertificateform">
						<div class="apply-flex">
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="allcertificateform.provinceId" placeholder="请选择省份"
										@change="provinceChange(allcertificateform)" style="width:150px">
										<el-option v-for="item in provinceOptions" :key="item.provinceId"
											:label="item.name" :value="item.provinceId">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="allcertificateform.cityId" placeholder="请选择市区"
										style="width:150px">
										<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
											:value="item.cityId">
										</el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="证书编号" prop='equipmentCode'>
									<el-input v-model="allcertificateform.operationCertificateNumber"
										style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="姓名" prop='ownerName'>
									<el-input v-model="allcertificateform.ownerName" style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="选择日期" prop='startendDate'>
									<el-date-picker style="width:300px" class="flex-rt"
										v-model="allcertificateform.startendDate" unlink-panels type="daterange"
										value-format='yyyy-MM-dd' range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
							</p>

							<p>
								<el-form-item label="证书状态" prop='ctStatus'>
									<el-select v-model="allcertificateform.ctStatus" placeholder="请选择证书状态">
										<el-option label="1个月过期" value="1"></el-option>
										<el-option label="未过期" value="2"></el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态" prop='dayinzhuangtai'>
									<el-select v-model="allcertificateform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									</el-select>
								</el-form-item>
							</p>
						</div>
					</el-form>

					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(allcertificateform,'')">查询
						</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileCertificate(allcertificateform,'','cerfirst')"
						>批量打印</el-button> -->

						<el-button type="primary" icon="el-icon-printer" class="handle-del"
							@click="listPrintPersonCertificate()">证件照打印</el-button>
					</p>

					<el-table :data="allcertificateTableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
						<el-table-column prop="operationItems" label="操作项"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center">
						</el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="validDate" label="有效日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">
								<el-button type="text" icon="el-icon-view">
									<!-- <router-link :to="'/cerapplyseefirst/'+ scope.row.certificateApplyId + '/'+query.pageIndex" style="color: #409EFF;">
										查看
									</router-link> -->
									<router-link :to="'/cerapplyseefirst/'+ scope.row.certificateApplyId + '/'+ceractiveName+'/'+query.pageIndex" style="color: #409EFF;">
										查看
									</router-link>
								</el-button>
								<el-button type="text" icon="el-icon-delete"
									@click="handleDelete(allcertificateform,'',scope.row,'cerfirst')">删除</el-button>

								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificate(allcertificateform,'',scope.row,'cerfirst')">证书打印
								</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="printCertificateZhengfuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正副本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateZhengben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateFuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证副本打印</el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange($event,allcertificateform,'')"></el-pagination>
					</div>


				</el-tab-pane>
				<el-tab-pane label="分支机构用户操作证书申请" name="cersecond">
					<el-form ref="secondcertificateform" :model="secondcertificateform" class="apply-flex">
						<div class="apply-flex">
							<p>
								<el-form-item label="业务员" prop='applicantName'>
									<el-input v-model="secondcertificateform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="姓名" prop='ownerName'>
									<el-input v-model="secondcertificateform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="secondcertificateform.provinceId" placeholder="请选择省份"
										@change="provinceChange(secondcertificateform)">
										<el-option v-for="item in provinceOptions" :key="item.provinceId"
											:label="item.name" :value="item.provinceId">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="secondcertificateform.cityId" placeholder="请选择市区">
										<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
											:value="item.cityId">
										</el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态" prop='dayinzhuangtai'>
									<el-select v-model="secondcertificateform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									</el-select>
								</el-form-item>
							</p>
						</div>


					</el-form>

					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search"
							@click="handleSearch(secondcertificateform,'3')">查询</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileCertificate(secondcertificateform,'3','cersecond')"
						>批量打印</el-button> -->
						<el-button type="primary" icon="el-icon-printer" class="handle-del"
							@click="listPrintPersonCertificate()">证件照打印</el-button>
					</p>

					<el-table :data="allcertificateTableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
						<el-table-column prop="operationItems" label="操作项目"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center">
						</el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="validDate" label="有效日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">

								<el-button type="text" icon="el-icon-view">
									<!-- <router-link :to="'/cerapplyseethird/'+scope.row.certificateApplyId" style="color: #409EFF;"> -->
									<router-link :to="`/cerapplyseethird/${scope.row.certificateApplyId}/${ceractiveName}/${query.pageIndex}`" style="color: #409EFF;">
										查看
									</router-link>
								</el-button>

								<el-button type="text" icon="el-icon-delete"
									@click="handleDelete(secondcertificateform,'3',scope.row,'cersecond')">删除
								</el-button>

								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificate(secondcertificateform,'3',scope.row,'cersecond')">
									证书打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="printCertificateZhengfuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正副本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateZhengben(secondcertificateform,'3',scope.row,'cersecond')">
									操作证正本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateFuben(secondcertificateform,'3',scope.row,'cersecond')">
									操作证副本打印</el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange($event,secondcertificateform,'3')"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="小程序用户操作证书申请" name="certhird">
					<el-form ref="thirdcertificateform" :model="thirdcertificateform" class="apply-flex">
						<div class="apply-flex">
							<p>
								<el-form-item label="业务员" prop='applicantOrganizationName'>
									<el-input v-model="thirdcertificateform.applicantOrganizationName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="姓名" prop='ownerName'>
									<el-input v-model="thirdcertificateform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="thirdcertificateform.provinceId" placeholder="请选择省份"
										@change="provinceChange(thirdcertificateform)">
										<el-option v-for="item in provinceOptions" :key="item.provinceId"
											:label="item.name" :value="item.provinceId">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="thirdcertificateform.cityId" placeholder="请选择市区">
										<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
											:value="item.cityId">
										</el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态" prop='dayinzhuangtai'>
									<el-select v-model="thirdcertificateform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									</el-select>
								</el-form-item>
							</p>
						</div>


					</el-form>

					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(thirdcertificateform,'5')">
							搜索</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileCertificate(thirdcertificateform,'5','certhird')"
						>批量打印</el-button> -->
						<el-button type="primary" icon="el-icon-printer" class="handle-del"
							@click="listPrintPersonCertificate()">证件照打印</el-button>
					</p>

					<el-table :data="allcertificateTableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
						<el-table-column prop="operationItems" label="操作姓名"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center">
						</el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="validDate" label="有效日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">

								<el-button type="text" icon="el-icon-view">
									<!-- <router-link :to="'/cerapplyseefirst/'+scope.row.certificateApplyId" style="color: #409EFF;"> -->
									<router-link :to="`/cerapplyseefirst/${scope.row.certificateApplyId}/${ceractiveName}/${query.pageIndex}`" style="color: #409EFF;">
										查看
									</router-link>
								</el-button>

								<el-button type="text" icon="el-icon-delete"
									@click="handleDelete(thirdcertificateform,'5',scope.row,'certhird')">删除</el-button>

								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificate(thirdcertificateform,'5',scope.row,'certhird')">证书打印
								</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="printCertificateZhengfuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正副本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateZhengben(thirdcertificateform,'5',scope.row,'certhird')">
									操作证正本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateFuben(thirdcertificateform,'5',scope.row,'certhird')">
									操作证副本打印</el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange($event,thirdcertificateform,'5')"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="总部业务员操作证书申请" name="cerfourth">
					<el-form ref="fourthcertificateform" :model="fourthcertificateform" class="apply-flex">
						<div class="apply-flex">
							<p>
								<el-form-item label="业务员" prop='applicantName'>
									<el-input v-model="fourthcertificateform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="姓名" prop='ownerName'>
									<el-input v-model="fourthcertificateform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="fourthcertificateform.provinceId" placeholder="请选择省份"
										@change="provinceChange(fourthcertificateform)">
										<el-option v-for="item in provinceOptions" :key="item.provinceId"
											:label="item.name" :value="item.provinceId">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="fourthcertificateform.cityId" placeholder="请选择市区">
										<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
											:value="item.cityId">
										</el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态" prop='dayinzhuangtai'>
									<el-select v-model="fourthcertificateform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									</el-select>
								</el-form-item>
							</p>
						</div>


					</el-form>

					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search"
							@click="handleSearch(fourthcertificateform,'2')">查询</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileCertificate(fourthcertificateform,'2','cerfourth')"
						>批量打印</el-button> -->
						<el-button type="primary" icon="el-icon-printer" class="handle-del"
							@click="listPrintPersonCertificate()">证件照打印</el-button>
						<el-button type="primary" icon="el-icon-document-add" class="handle-del"
							@click="ceraddbtn('ceraddform')">添加证书</el-button>
					</p>

					<el-table :data="allcertificateTableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
						<el-table-column prop="operationItems" label="操作姓名"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center">
						</el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="validDate" label="有效日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">

								<el-button type="text" icon="el-icon-view">
								<!-- 	<router-link :to="'/cerapplyseesec/'+scope.row.certificateApplyId" style="color: #409EFF;">
										查看
									</router-link> -->
									<router-link :to="'/cerapplyseesec/'+scope.row.certificateApplyId+'/'+ceractiveName+'/'+query.pageIndex" style="color: #409EFF;">
										查看
									</router-link>
									
								</el-button>

								<el-button type="text" icon="el-icon-delete"
									@click="handleDelete(fourthcertificateform,'2',scope.row,'cerfourth')">删除
								</el-button>

								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificate(fourthcertificateform,'2',scope.row,'cerfourth')">
									证书打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="printCertificateZhengfuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正副本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateZhengben(fourthcertificateform,'2',scope.row,'cerfourth')">
									操作证正本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateFuben(fourthcertificateform,'2',scope.row,'cerfourth')">
									操作证副本打印</el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange($event,fourthcertificateform,'2')"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="厂商业务员操作证申请" name="cerfifth">
					<el-form ref="fifthcertificateform" :model="fifthcertificateform" class="apply-flex">
						<div class="apply-flex">
							<p>
								<el-form-item label="业务员" prop='applicantName'>
									<el-input v-model="fifthcertificateform.applicantName"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="姓名" prop='ownerName'>
									<el-input v-model="fifthcertificateform.ownerName"></el-input>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="fifthcertificateform.provinceId" placeholder="请选择省份"
										@change="provinceChange(fifthcertificateform)">
										<el-option v-for="item in provinceOptions" :key="item.provinceId"
											:label="item.name" :value="item.provinceId">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="fifthcertificateform.cityId" placeholder="请选择市区">
										<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
											:value="item.cityId">
										</el-option>
									</el-select>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="打印状态" prop='dayinzhuangtai'>
									<el-select v-model="fifthcertificateform.dayinzhuangtai" placeholder="请选择打印状态">
										<el-option label="已打印" value="2"></el-option>
										<el-option label="未打印" value="1"></el-option>
									</el-select>
								</el-form-item>
							</p>
						</div>


					</el-form>

					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch(fifthcertificateform,'4')">
							查询</el-button>
						<!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del  "
							@click="listPrintFileCertificate(fifthcertificateform,'4','cerfifth')"
						>批量打印</el-button> -->
						<el-button type="primary" icon="el-icon-printer" class="handle-del"
							@click="listPrintPersonCertificate()">证件照打印</el-button>
					</p>

					<el-table :data="allcertificateTableData" border class="table" ref="multipleTable"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
						<el-table-column prop="operationItems" label="操作姓名"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center">
						</el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="validDate" label="有效日期" align="center"></el-table-column>
						<el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">

								<el-button type="text" icon="el-icon-view">
									<!-- <router-link :to="'/cerapplyseesec/'+scope.row.certificateApplyId" style="color: #409EFF;"> -->
										<router-link :to="`/cerapplyseesec/${scope.row.certificateApplyId}/${ceractiveName}/${query.pageIndex}`" style="color: #409EFF;">
										查看
									</router-link>
								</el-button>

								<el-button type="text" icon="el-icon-delete"
									@click="handleDelete(fifthcertificateform,'4',scope.row,'cerfifth')">删除</el-button>

								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificate(fifthcertificateform,'4',scope.row,'cerfifth')">证书打印
								</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="printCertificateZhengfuben(allcertificateform,'',scope.row,'cerfirst')">
									操作证正副本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateZhengben(fifthcertificateform,'4',scope.row,'cerfifth')">
									操作证正本打印</el-button>
								<el-button type="text" icon="el-icon-printer"
									@click="getprintFileCertificateFuben(fifthcertificateform,'4',scope.row,'cerfifth')">
									操作证副本打印</el-button>

							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange($event,fifthcertificateform,'4')"></el-pagination>
					</div>
				</el-tab-pane>

			</el-tabs>
		</div>


		<el-dialog class="branch-dialog" title="添加操作证书" :visible.sync="ceraddVisible" width="600px">
			<el-form ref="ceraddform" :model="ceraddform" :rules="ceraddrules">
				<!-- <el-form-item label="区域" prop="areaAddress">
					<el-cascader ref="cascaderAddr" :options="cityList" :props="optionProps" v-model="ceraddform.areaAddress" style="width: 100%;"></el-cascader>
				</el-form-item> -->
				<el-form-item label="区域" prop="provinceId">
					<el-select v-model="ceraddform.provinceId" placeholder="请选择省份" @change="provinceChange(ceraddform)"
						style="width: 100%;">
						<el-option v-for="item in provinceOptions" :key="item.provinceId" :label="item.name"
							:value="item.provinceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="" prop="cityId">
					<el-select v-model="ceraddform.cityId" placeholder="请选择市区" style="width: 100%;">
						<el-option v-for="item in citysOptions" :key="item.cityId" :label="item.name"
							:value="item.cityId">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="姓名" prop="ownerName">
					<el-input v-model="ceraddform.ownerName"></el-input>
				</el-form-item>
				<el-form-item label="电话" prop="ownerCellphoneNumber">
					<el-input v-model="ceraddform.ownerCellphoneNumber"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="ownerSex">
					<el-radio-group v-model="ceraddform.ownerSex">
						<el-radio label="1">男</el-radio>
						<el-radio label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label="文化程度" prop="ownerEducationDegree" class="select-width">
		            <el-select v-model="ceraddform.ownerEducationDegree" placeholder="请选择">
		                <el-option label="小学" value="1"></el-option>
						<el-option label="初中" value="2"></el-option>
						<el-option label="高中" value="3"></el-option>
						<el-option label="大学" value="4"></el-option>
		              </el-select>
		        </el-form-item> -->
				<el-form-item label="文化程度" prop="ownerEducationDegree">
					<el-input v-model="ceraddform.ownerEducationDegree"></el-input>
				</el-form-item>
				<el-form-item label="操作项目" prop="operationItems">
					<el-input v-model="ceraddform.operationItems"></el-input>
				</el-form-item>
				<el-form-item label="身份证号码" prop="ownerIdentityCards">
					<el-input v-model="ceraddform.ownerIdentityCards"></el-input>
				</el-form-item>

				<el-form-item class="cer_photo" ref='ownerCredentialsPhoto' label="添加证件照" prop="ownerCredentialsPhoto">
					<el-upload class="avatar-uploader avatar-box" action="/api/homepage/uploadImages"
						list-type="picture-card" :show-file-list="false" :on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="ceraddform.ownerCredentialsPhoto"
							:src="'/api/static'+ceraddform.ownerCredentialsPhoto" class="avatar">
						<i v-else class="el-icon-plus"></i>
					</el-upload>

				</el-form-item>


				<el-form-item label="收货人姓名" prop="shippingName">
					<el-input v-model="ceraddform.shippingName"></el-input>
				</el-form-item>
				<el-form-item label="收货人手机号" prop="shippingCellphoneNumber">
					<el-input v-model="ceraddform.shippingCellphoneNumber"></el-input>
				</el-form-item>

				<el-form-item label="收货人省市县" prop="shippingArea">
					<el-cascader :options="cityxcList" :props="optionxcProps" v-model="ceraddform.shippingArea"
						style="width: 100%;"></el-cascader>
				</el-form-item>
				<el-form-item label="详细地址" prop="shippingDetailedAddress">
					<el-input v-model="ceraddform.shippingDetailedAddress"></el-input>
				</el-form-item>

			</el-form>



			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="ceraddSave('ceraddform')">确 定</el-button>
				<el-button @click="ceraddVisible = false">取 消</el-button>
			</span>
		</el-dialog>



		<el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
			<div class="cropper-content">
				<div class="cropper" style="text-align:center">
					<vueCropper ref="cropper" :img="option.img" :outputSize="option.outputSize"
						:outputType="option.outputType" :info="option.info" :canScale="option.canScale"
						:autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
						:autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedBox="option.fixedBox"
						:fixedNumber="option.fixedNumber"></vueCropper>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="finish" :loading="loading">确认</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		VueCropper
	} from 'vue-cropper'
	import {
		listProvinces,
		listProvinceCityCountys,
		listCitysByProvinceId,
		listCertificateApplys,
		printFileCertificateFirst,
		printFileCertificateSecond,
		printFileLicense,
		savePcCertificateApply,
		printCertificateApplys,
		deleteCertificateApply,
		printFilePersonCertificate,
		printFileCertificateZhengben,
		printFileCertificateFuben,
		printFileCertificateZhengfuben
	} from '../api/index';

	export default {
		name: 'certificateapplys',
		components: {
			VueCropper
		},
		data() {
			var validPhone = (rule, value, callback) => {
				// debugger 
				const phoneReg =
					/^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
				if (!value) {
					return callback(new Error('电话号码不能为空'))
				} else if (!Number.isInteger(+value)) {
					callback(new Error('请输入数字值'))
				} else {
					if (phoneReg.test(value)) {
						callback()
					} else {
						callback(new Error('电话号码格式不正确'))
					}
				}
			};
			var validIdNum = (rule, value, callback) => {
				const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
				if (!value) {
					return callback(new Error('证件号码不能为空'))
				} else if (!reg.test(value)) {
					return callback(new Error('证件号码不正确'))
				} else {
					callback()
				}
			};
			return {
				val: 1, //分页页码数
				// cityList:[],//省市数据
				cityxcList: [],
				// optionProps: {
				// 	// TODO
				// 		value: 'id',
				// 		label: 'name'
				// },   //省市联动重命名指向
				optionxcProps: {
					// TODO
					value: 'name',
					label: 'name'
				}, //省市联动重命名指向

				ceractiveName: 'cerfirst',
				provinceOptions: [], //省列表
				citysOptions: [], //市列表
				
				allcertificateform: {
					provinceId: '',
					cityId: '',
					equipmentCode: '', //牌照编号
					ownerName: '', //车主姓名
					startendDate: '', //日期
					cdStatus: '',
					dayinzhuangtai: '',
				}, //所有的搜索表单
				secondcertificateform: {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				},
				thirdcertificateform: {
					applicantOrganizationName: '', //分支机构
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				},
				fourthcertificateform: {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				},
				fifthcertificateform: {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				},
				query: {
					pageIndex: this.$route.params.pageIndex,
					pageSize: 10
				}, //分页
				allcertificateTableData: [],
				multipleSelection: [],
				editVisible: false,
				pageTotal: 0,

				ceraddVisible: false,
				ceraddform: {
					provinceId: '',
					cityId: '',
					ownerName: '',
					ownerCellphoneNumber: '',
					ownerSex: '1',
					ownerEducationDegree: '',
					operationItems: '',
					ownerIdentityCards: '',
					ownerCredentialsPhoto: '',


					shippingName: '',
					shippingCellphoneNumber: '',
					shippingAreaCode: '',
					shippingArea: '',
					shippingDetailedAddress: ''
				}, //添加机构分支表单
				ceraddrules: {
					shippingName: [{
						required: true,
						message: '请输入收货人姓名',
						trigger: ['blur', 'change']
					}],
					shippingCellphoneNumber: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validPhone
					}],
					shippingArea: [{
						required: true,
						message: '收货人省市县不能为空',
						trigger: ['blur', 'change']
					}],
					shippingDetailedAddress: [{
						required: true,
						message: '收货人详细地址不能为空',
						trigger: ['blur', 'change']
					}],


					provinceId: [{
						required: true,
						message: '请选择省',
						trigger: ['blur', 'change']
					}],
					cityId: [{
						required: true,
						message: '请选择市',
						trigger: ['blur', 'change']
					}],
					ownerName: [{
						required: true,
						message: '请输入姓名',
						trigger: ['blur', 'change']
					}],
					ownerCellphoneNumber: [{
						required: true,
						validator: validPhone,
						trigger: ['blur', 'change']
					}],
					operationItems: [{
						required: true,
						message: '请输入操作项目',
						trigger: ['blur', 'change']
					}],
					ownerIdentityCards: [{
						required: true,
						validator: validIdNum,
						trigger: ['blur', 'change']
					}],
					ownerCredentialsPhoto: [{
						required: true,
						message: '请上传证件照',
						trigger: 'change'
					}]

				}, //添加表单验证

				//牌照
				dialogVisible: false,
				// 裁剪组件的基础配置option
				option: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 1, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: false, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 200, // 默认生成截图框宽度
					autoCropHeight: 300, // 默认生成截图框高度
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1.5], // 截图框的宽高比例   添加牌照比例   1.3:1   添加操作证书  1:1.5
					full: true, // 是否输出原图比例的截图
					canMoveBox: false, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
					canMove: true,
				},
				// 防止重复提交
				loading: false,
				//isChange: this.$route.query.isChange ? this.$route.query.isChange : true,
				fileinfo: {},


			}
		},
		created() {
			this.ceractiveName = this.$route.params.ceractiveName;
			this.query.pageIndex = this.$route.params.pageIndex;
			
			let organizationKind = '';
			let form = this.allLicenselyform;
			
			switch(this.ceractiveName){
				case 'cerfirst':
					organizationKind = '';
					// form = this.allLicenselyform;
					break;
				case 'cersecond':
					organizationKind = 3;
					form = this.secondcertificateform
					break;
				case 'certhird':
					organizationKind = 5;
					form = this.thirdcertificateform
					break;
				case 'cerfourth':
					organizationKind = 2;
					form = this.fourthcertificateform
					break;
				case 'cerfifth':
					organizationKind = 4;
					form = this.fifthcertificateform
					break;
			}
			// this.getlistCertificateApplys(form,organizationKind,this.query.pageIndex)
			this.getlistCertificateApplys({},organizationKind,this.query.pageIndex)
				
			var that = this;
			// 省
			listProvinces({}).then(res => {
				// 获取数据成功后的其他操作
				that.provinceOptions = res.data;
			});


			listProvinceCityCountys({}).then(res => {
				// 获取数据成功后的其他操作
				that.cityxcList = res.data;
			});
			// this.getlistCertificateApplys(this.allcertificateform, '', this.$route.params.pageIndex);
		},
		methods: {
			// 省改变请求市
			provinceChange(Licenselyform) {
				Licenselyform.cityId = '';
				listCitysByProvinceId({
					provinceId: Licenselyform.provinceId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.citysOptions = res.data;
				});
			},
			getlistCertificateApplys(form, organizationKind, current) {
				var LicenseApplyobj = {};
				if (form.startendDate) {
					form.startDate = form.startendDate[0];
					form.endDate = form.startendDate[1];
				}
				LicenseApplyobj = form;
				LicenseApplyobj.organizationKind = organizationKind;
				LicenseApplyobj.current = current;
				LicenseApplyobj.size = this.query.pageSize;
				listCertificateApplys(LicenseApplyobj).then(res => {
					// 获取数据成功后的其他操作
					console.log(res.data.records)
					console.log(res.data.total)
					this.allcertificateTableData = res.data.records;
					this.pageTotal = res.data.total;
				});
			},


			handleClick(tab, event) {
				this.val = 1
				this.allcertificateform = {
					provinceId: '',
					cityId: '',
					equipmentCode: '', //牌照编号
					ownerName: '', //车主姓名
					startendDate: '' //日期
				};
				this.secondcertificateform = {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				};
				this.thirdcertificateform = {
					applicantOrganizationName: '', //分支机构
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				};
				this.fourthcertificateform = {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				};
				this.fifthcertificateform = {
					applicantName: '', //业务员
					ownerName: '', //车主姓名
					provinceId: '',
					cityId: '',
					dayinzhuangtai: '',
				};
				this.allcertificateTableData = [];
				var organizationKind = '';
				if (tab.name == 'cerfirst') {
					organizationKind = '';
				} else if (tab.name == 'certhird') {
					organizationKind = 5;
				} else if (tab.name == 'cersecond') {
					organizationKind = 3;
				} else if (tab.name == 'cerfourth') {
					organizationKind = 2;
				} else if (tab.name == 'cerfifth') {
					organizationKind = 4;
				}
				this.query.pageIndex = 1;
				this.getlistCertificateApplys({}, organizationKind, 1);
			},

			// 触发搜索按钮
			handleSearch(form, organizationKind) {
				this.getlistCertificateApplys(form, organizationKind, 1);
			},
			// 删除操作
			handleDelete(form, organizationKind, row, activeName) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
					type: 'warning'
				}).then(() => {
					deleteCertificateApply({
						"certificateApplyId": row.certificateApplyId
					}).then(res => {
						this.activeName = activeName;
						this.getlistCertificateApplys(form, organizationKind, 1);
						if (res.code == 0) {
							// 获取数据成功后的其他操作
							this.$message({
								message: res.message,
								type: 'success'
							});
						} else if (res.code == 1) {
							this.$message({
								message: res.message,
								type: 'warning'
							});
						} else {
							this.$message({
								message: '报错啦!',
								type: 'warning'
							});
						}

					});
				}).catch(() => {});
			},
			//打印
			getprintFileCertificate(form, organizationKind, row, activeName) {
				row.ownerCredentialsPhoto2 = '/api/static' + row.ownerCredentialsPhoto;
				printFileCertificateFirst(row);
				//printFileCertificateSecond(row);
				printCertificateApplys({
					"certificateApplyIds": row.certificateApplyId
				}).then(res => {
					console.log(this.val)
					// 获取数据成功后的其他操作
					this.activeName = activeName;
					this.getlistCertificateApplys(form, organizationKind, this.val);
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},
			// 操作证正副本打印
			printCertificateZhengfuben(form, organizationKind, row, activeName) {
				printFileCertificateZhengfuben(row);
				printCertificateApplys({
					"certificateApplyIds": row.certificateApplyId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.activeName = activeName;
					this.getlistCertificateApplys(form, organizationKind, this.val);
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},
			// 操作证 - 正本   printFileCertificateZhengben
			getprintFileCertificateZhengben(form, organizationKind, row, activeName) {
				printFileCertificateZhengben(row);
				printCertificateApplys({
					"certificateApplyIds": row.certificateApplyId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.activeName = activeName;
					this.getlistCertificateApplys(form, organizationKind, this.val);
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},

			// 操作证 - 副本  
			getprintFileCertificateFuben(form, organizationKind, row, activeName) {
				printFileCertificateFuben(row);
				printCertificateApplys({
					"certificateApplyIds": row.certificateApplyId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.activeName = activeName;
					this.getlistCertificateApplys(form, organizationKind, this.val);
					this.$message({
						message: res.message,
						type: 'success'
					});
				})
			},


			// 批量打印
			listPrintFileCertificate(form, organizationKind, activeName) {
				// 获取选中的行记录
				// console.log(this.multipleSelection);
				var certificateApplyId = '';
				if (this.multipleSelection.length > 0) {
					for (var i in this.multipleSelection) {
						var obj1 = this.multipleSelection[i];
						// ownerCredentialsPhoto
						obj1.ownerCredentialsPhoto2 = '/api/static' + obj1.ownerCredentialsPhoto;
						printFileCertificateFirst(obj1);
						printFileCertificateSecond(obj1);
						if (i == 0) {
							certificateApplyId += this.multipleSelection[i].certificateApplyId;
						} else {
							certificateApplyId += ',' + this.multipleSelection[i].certificateApplyId;
						}
					}
				} else {
					this.$message({
						message: '没有选择打印项哦',
						type: 'warning'
					});
					return false;
				}

				// console.log(certificateApplyId);
				printCertificateApplys({
					"certificateApplyIds": certificateApplyId
				}).then(res => {
					// 获取数据成功后的其他操作
					this.activeName = activeName;
					this.getlistCertificateApplys(form, organizationKind, 1);
					this.$message({
						message: res.message,
						type: 'success'
					});
				})

			},

			// 打印个人证件照
			listPrintPersonCertificate() {
				// 获取选中的行记录
				var ownerCredentialsPhotoArr = [];
				var ownerNameArr = [];

				if (this.multipleSelection.length <= 0) {
					this.$message({
						message: '没有选择打印项哦',
						type: 'warning'
					});
					return false;
				}

				if (this.multipleSelection.length > 9) {
					this.$message({
						message: '最多选择9条记录哦',
						type: 'warning'
					});
					return false;
				}

				for (var i in this.multipleSelection) {
					if (this.multipleSelection[i].ownerCredentialsPhoto) {
						var ownerCredentialsPhoto = '/api/static' + this.multipleSelection[i].ownerCredentialsPhoto;
						ownerCredentialsPhotoArr.push(ownerCredentialsPhoto);

						var ownerName = this.multipleSelection[i].ownerName;
						ownerNameArr.push(ownerName);
					}
				}

				// ceshi
				/* for(var i=1;i<=8;i++){
					var photo = 'http://www.c-lodop.com/demolist/PrintSample8.jpg';
					ownerCredentialsPhotoArr.push(photo);
					ownerNameArr.push("张三");
				} */
				// ceshi

				var ownerCredentialsPhotoparams = {};
				ownerCredentialsPhotoparams.pics = ownerCredentialsPhotoArr;
				ownerCredentialsPhotoparams.names = ownerNameArr;
				console.log(ownerCredentialsPhotoparams, 11111111111)
				printFilePersonCertificate(ownerCredentialsPhotoparams);
			},

			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAllSelection() {

			},

			// 总部添加证书
			// 牌照照片
			handleAvatarSuccess(res, file, fileList) {
				//上传成功后将图片地址赋值给裁剪框显示图片
				this.$nextTick(() => {
					this.option.img = URL.createObjectURL(file.raw);
					this.fileinfo = res
					this.dialogVisible = true
				})
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				const isPng = file.type === 'image/png'
				const isLt2M = file.size / 1024 / 1024 < 2

				if (!isJPG && !isPng) {
					this.$message.error('上传图片只能是 JPG或png 格式!')
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!')
				}
				return (isJPG || isPng) && isLt2M
			},
			finish() { //截图提交
				this.$refs.cropper.getCropBlob((data) => {
					var fileName = 'goods' + this.fileinfo.uid
					this.loading = true
					var formData = new FormData();
					formData.append("file", data);
					this.$http({
						method: 'post',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						url: "/api/homepage/uploadImages",
						data: formData,
						crossDomain: true,
						cache: false
					}).then(res => {
						this.dialogVisible = false;
						this.$refs.ownerCredentialsPhoto.clearValidate();
						this.ceraddform.ownerCredentialsPhoto = res.data.data[0];
						this.loading = false;
					}).catch(() => {
						this.loading = false;
						this.$message.error('上传失败，请重新上传');
					})

				})
			},

			ceraddbtn(formName) {
				this.ceraddVisible = true;
				//重置表单数据
				this.$nextTick(() => {
					this.$refs. [formName].resetFields();
				})

			},



			ceraddSave(formName) {

				this.$refs[formName].validate((valid) => {
					if (valid) {
						var shippingArea = '';
						for (var i in this.ceraddform.shippingArea) {
							if (i == 0) {
								shippingArea += this.ceraddform.shippingArea[i];
							} else {
								shippingArea += '-' + this.ceraddform.shippingArea[i];
							}
						}
						this.ceraddform.shippingArea = shippingArea;
						this.ceraddform.fromVal = localStorage.getItem('role')==20? 2 : ''

						savePcCertificateApply(this.ceraddform).then(res => {
							if (res.code == 0) {
								// 获取数据成功后的其他操作
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.ceractiveName = 'cerfourth';
								this.getlistCertificateApplys({}, 2, 1);
								this.ceraddVisible = false;
							} else if (res.code == 1) {
								this.$message({
									message: res.message,
									type: 'warning'
								});
							} else {
								this.$message({
									message: '报错啦!',
									type: 'warning'
								});
							}

						});
					} else {
						return false;
					}
				});
			},


			// 分页导航
			handlePageChange(val, form, kind) {
				this.val = val
				console.log(val)
				console.log(form)
				console.log(form, kind),
					console.log(this.query)
				this.$set(this.query, 'pageIndex', val);
				this.getlistCertificateApplys(form, kind, val);
			}
		},
		computed: {

		}
	}
</script>


<style scoped>
	.apply-flex {
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
	}

	.apply-flex p {
		width: 25%;
		margin-right: 20px;
	}

	.apply-flex p.apply-flexarea .el-form-item {
		margin-right: 10px;
	}

	.apply-flex p.apply-flexarea {
		width: 40%;
		display: flex;
		display: -webkit-flex;
	}

	.apply-flex .el-form-item {
		display: flex;
		display: -webkit-flex;
	}


	.flex-btn {
		margin-bottom: 20px;
		text-align: right;
		border-top: 1px solid #ddd;
		padding-top: 10px;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>


<style>
	/* 上传 */
	.avatar-box .el-upload.el-upload--text {
		width: 240px;
		line-height: 180px;
	}

	.avatar-box .el-upload.el-upload--text img {
		width: 100%;
		height: 100%;
	}

	.apply-flex p .el-form-item__label {
		width: 80px;
	}

	.cropper-content {
		width: 500px;
		height: 500px;
		background: pink;
	}

	.cropper {
		width: 500px;
		height: 500px;
		background: yellow;
	}

	.cer_photo .el-upload--picture-card {
		width: 100px;
		height: 150px;
		line-height: 150px;
	}

	.cer_photo .el-upload--picture-card img {
		width: 100%;
		height: 100%;
	}
</style>
